import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:"filterCompanyName"
    ,pure: false
})
export class FilterCompanyName implements PipeTransform {
    transform(items : any[],filter:string) {
        if(!items || !filter){
            return items;
        }

        return items.filter((val,idx) => {
            if(val.companyNm.indexOf(filter) > -1){
                return true;
            }else{
                return false;
            }
        });
    }
}